'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$HowSection(eyebrow, title, steps) {
  this.ih = null;
  this.ij = null;
  this.ii = null;
  this.ih = eyebrow;
  this.ij = title;
  this.ii = steps;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$HowSection as $c_Lio_intela_sites_digitalinternship_data_Segments$HowSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$HowSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$HowSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$HowSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$HowSection as $h_Lio_intela_sites_digitalinternship_data_Segments$HowSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$HowSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 1445251851, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$HowSection)) {
    if (((this.ih === x$0.ih) && (this.ij === x$0.ij))) {
      var x = this.ii;
      var x$2 = x$0.ii;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "HowSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ih;
      break;
    }
    case 1: {
      return this.ij;
      break;
    }
    case 2: {
      return this.ii;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HowSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bB)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HowSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$HowSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$HowSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$HowSection, "io.intela.sites.digitalinternship.data.Segments$HowSection", ({
  bB: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$HowSection as $d_Lio_intela_sites_digitalinternship_data_Segments$HowSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-How-Section.js.map
